import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import styles from "./ScheduledFor.module.css";

type ScheduledForProps = {
  text: string;
};

function ScheduledFor({ text }: ScheduledForProps) {
  return <FixaText className={styles["root"]}>{text}</FixaText>;
}

export default ScheduledFor;
